import { dispatch, pathSubscription } from 'nike-re-framejs';
import { nuiCtx } from '../../common/initialization';
import axios from 'axios';
import { MessageDialog, openDialog } from '../dialogs/dialogs';
import * as Immutable from 'immutable';
import { Dialog2FA } from '../2fa/views/Wizard2FA';
import { set2FAContext } from '../2fa';
import i18n from '../../common/i18n';

export const servicesExtra$ = () =>
    nuiCtx.platform === 'mobile'
        ? pathSubscription(['myprofile', 'profile', 'fetched', 'servicesExtra'])
        : pathSubscription(['account', 'user', 'servicesExtra']);

const hideDepositPath = ['account', 'userConfig', 'hideDeposit'];
const hideDepositLsKey = 'header.hideWalletValues';

export const hideDeposit$ = pathSubscription(hideDepositPath);

export const toggleHideDeposit = db => {
    const showDeposit = !db.getIn(hideDepositPath);
    localStorage.setItem(hideDepositLsKey, String(showDeposit));
    return db.setIn(hideDepositPath, showDeposit);
};

export const initHideDeposit = db => {
    //TODO tento if zmazat o rok neskor :)
    if (localStorage.getItem('nikeUserDeposit')) {
        localStorage.setItem(hideDepositLsKey, String(localStorage.getItem('nikeUserDeposit') === 'hidden'));
        localStorage.removeItem('nikeUserDeposit');
    }
    return db.setIn(hideDepositPath, localStorage.getItem(hideDepositLsKey) === 'true');
};

const gridPath = ['userConfig', 'grid'];
const gridEnabledOriginalPath = ['userConfig', 'gridEnabled'];
const setGridPosition = gridPosition => db => db.setIn([...gridPath, 'gridPosition'], gridPosition);
export const setGridEnabled = gridEnabled => db => db.setIn([...gridPath, 'gridEnabled'], gridEnabled);
export const setGridValue = gridCode => db => db.setIn([...gridPath, 'gridCode'], gridCode);
const setGrid = grid => db => db.setIn(gridPath, grid).setIn(gridEnabledOriginalPath, grid.get('gridEnabled'));
const mergeGrid = grid => db => db.mergeIn(gridPath, grid);
export const gridConfig$ = pathSubscription(gridPath, Immutable.Map());
export const gridEnabledOriginal$ = pathSubscription(gridEnabledOriginalPath);
export const gridError$ = pathSubscription([...gridPath, 'gridError']);

export const fetchGrid = () => {
    axios
        .get(gridCardUri)
        .then(json => dispatch(setGrid(Immutable.fromJS(json))))
        .catch(() => null);
};

export const sendGridForm = grid =>
    axios
        .post(gridCardUri, grid.toJS())
        .then(json => {
            //@ts-ignore
            if (json.messages) {
                //@ts-ignore
                openDialog(MessageDialog, { message: i18n(json.messages[0]) });
                fetchGrid();
            } else {
                dispatch(mergeGrid(Immutable.fromJS(json)));
            }
            return json;
        })
        .catch(error => {
            const gridPosition = error?.response?.data?.gridPosition;
            if (gridPosition) {
                dispatch(setGridPosition(gridPosition));
            }
        });

const gridCardUri = '/api/customer/grid-card-status';

export function start2FAWizard({ jwt, methods }, reason, payload, callback) {
    return db => [
        db.deleteIn(['2FA']),
        () => set2FAContext(jwt, methods, reason, payload, callback),
        () => openDialog(Dialog2FA)
    ];
}
